module.exports = __webpack_public_path__ + "img/1534760915.386bc362.jpg";